require('angular').module('wowApp.common')
    .service('ProgressivePagingService', [require('./progressive-paging-service')])
    .directive('pagingControl', ['$timeout', require('./paging-directive')])
    .directive('progressivePagingControl', ['ProgressivePagingService', 'FiltersService', require('./progressive-paging-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/paging/index.js
 **/